import React from "react";
import camelcaseKeys from "camelcase-keys";
import { apiResourceUrl, legacyApiResourceUrl } from "@ploy-lib/core";
export class CommissionAPI extends React.Component {
    constructor() {
        super(...arguments);
        this.callAPI = async (method, action, params) => {
            const { token } = this.props;
            const noCacheToken = new Date().getTime();
            const response = await fetch(apiResourceUrl(`backoffice-commission/${action}?${getQueryParams(params)}&t=${noCacheToken}`), {
                method,
                headers: token ? new Headers({ Authorization: token }) : undefined,
                credentials: "include" // Include session cookie
            });
            const data = await response.json();
            return camelcaseKeys(data);
        };
        this.handleGetCommission = async (searchParams) => {
            try {
                const response = await this.callAPI("GET", searchParams.type, {
                    ...searchParams
                });
                return {
                    ...response,
                    commissions: response.commissions.map((x) => ({
                        ...x,
                        startDate: new Date(x.startDate),
                        date: new Date(x.date)
                    }))
                };
            }
            catch (err) {
                throw Error("Error getting backoffice commission. " + err.message);
            }
        };
        this.handleGetAdditionalInformation = async (monthYear, agreementNumber, useEntireHierarki) => {
            try {
                const response = await this.callAPI("GET", "additional-info", {
                    monthYear,
                    agreementNumber,
                    useEntireHierarki
                });
                return {
                    ...response,
                    agreementNumber
                };
            }
            catch (err) {
                throw Error("Error getting backoffice commission. " + err.message);
            }
        };
        this.handleGetApplicationInformation = async (contracts) => {
            try {
                const response = await this.callAPI("GET", "application-info", {
                    contracts
                });
                return { ...response };
            }
            catch (err) {
                throw Error(`Error getting backoffice commission. ${err.message}`);
            }
        };
        this.handleSendToApproval = async (agreements) => {
            const { token } = this.props;
            try {
                const response = await fetch(apiResourceUrl("backoffice-commission/log"), {
                    method: "POST",
                    headers: token ? new Headers({ Authorization: token }) : undefined,
                    credentials: "include", // Include session cookie
                    body: new Blob([JSON.stringify(agreements)], {
                        type: "application/json"
                    })
                });
                const data = await response.json();
                return camelcaseKeys(data);
            }
            catch (err) {
                throw Error("Error getting backoffice commission. " + err.message);
            }
        };
        this.handleSearchVendor = async (searchString) => {
            try {
                var response = await fetch(legacyApiResourceUrl(`/VendorSelect/SearchVendorsByPartialName?data=${encodeURIComponent(searchString)}`), {
                    method: "GET",
                    credentials: "include" // Include session cookie
                });
                const data = await response.json();
                return data;
            }
            catch (err) {
                throw Error("Error when searching vendors. " + err.message);
            }
        };
        this.handleSearchUnderwriter = async (searchString) => {
            try {
                var response = await fetch(legacyApiResourceUrl(`/User/SearchUserByPartialName?data=${encodeURIComponent(searchString)}`), {
                    method: "GET",
                    credentials: "include" // Include session cookie
                });
                const data = await response.json();
                return data;
            }
            catch (err) {
                throw Error("Error when searching vendors. " + err.message);
            }
        };
        this.handleUpdateStatus = async (agreement) => {
            const { token } = this.props;
            try {
                var response = await fetch(apiResourceUrl(`backoffice-commission/update-status`), {
                    method: "POST",
                    headers: token ? new Headers({ Authorization: token }) : undefined,
                    credentials: "include", // Include session cookie
                    body: new Blob([JSON.stringify(agreement)], {
                        type: "application/json"
                    })
                });
                const data = await response.json();
                return data;
            }
            catch (err) {
                throw Error("Error when searching vendors. " + err.message);
            }
        };
    }
    render() {
        const { children } = this.props;
        return children({
            getCommission: this.handleGetCommission,
            sendToApproval: this.handleSendToApproval,
            vendorSearch: this.handleSearchVendor,
            underwriterSearch: this.handleSearchUnderwriter,
            getAdditionalInformation: this.handleGetAdditionalInformation,
            getApplicationInformation: this.handleGetApplicationInformation,
            updateStatus: this.handleUpdateStatus
        });
    }
}
export const getQueryParams = (params) => {
    return Object.entries(params)
        .map(([k, v]) => encodeURIComponent(k) +
        "=" +
        encodeURIComponent(v instanceof Date ? v.toISOString() : v))
        .join("&");
};
export default CommissionAPI;
//# sourceMappingURL=CommissionAPI.js.map